import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "Home absolute inset-0 flex flex-col justify-center items-center gap-32" };
const _hoisted_2 = { class: "container place-items-end h-full py-80 lg:py-64" };
const _hoisted_3 = { class: "col-start-2 col-span-8 lg:col-start-2 lg:col-span-10" };
import { computed, onMounted } from "vue";
import Viewport from "@/store/modules/Viewport";
import { useAppState } from "@/services/Composition";
import { setLayoutTheme } from "@/store/modules/LayoutTheme";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HomePage',
    setup(__props) {
        const { state, send } = useAppState();
        const showCTA = computed(() => process.env.VUE_APP_SKIP_INTRO === "true" || state.value.matches("home.home.page.enterExperience"));
        const showSkip = computed(() => state.value.can("SKIP"));
        const next = () => send("NEXT");
        const skip = () => send("SKIP");
        onMounted(() => {
            setLayoutTheme("dark");
        });
        return (_ctx, _cache) => {
            const _component_UIBtn = _resolveComponent("UIBtn");
            const _component_UIRoundCta = _resolveComponent("UIRoundCta");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (showSkip.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "absolute inset-0 flex flex-col items-center justify-end pb-80",
                        onClick: _cache[0] || (_cache[0] = ($event) => (!_unref(Viewport).isTouch && skip()))
                    }, [
                        (_unref(Viewport).isTouch)
                            ? (_openBlock(), _createBlock(_component_UIBtn, {
                                key: 0,
                                variant: "solid",
                                theme: "light",
                                onClick: skip
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(Viewport).isMobile ? _ctx.$t("global.continue") : _ctx.$t("global.skip")), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])), [
                        [
                            _directive_sound,
                            _unref(Viewport).isTouch ? false : 'UI_SECONDARY_CLICK',
                            void 0,
                            { click: true }
                        ]
                    ])
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (showCTA.value)
                            ? (_openBlock(), _createBlock(_component_UIRoundCta, {
                                key: 0,
                                text: _ctx.$t('home.cta'),
                                hover: _unref(Viewport).isTouch,
                                onClick: next
                            }, null, 8, ["text", "hover"]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
